// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-table-template {
  display: flex;
  gap: 10px;
  padding: 6px 12px 6px 45px;
  align-items: center;
  position: relative;
}
.mini-table-template .mini-left-click, .mini-table-template .mini-right-click {
  position: absolute;
  border-radius: 32px;
  background: var(--sdk-global-white);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  left: 20px;
  top: auto;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 9;
}
.mini-table-template .mini-left-click svg path, .mini-table-template .mini-right-click svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.mini-table-template .mini-left-click.hide, .mini-table-template .hide.mini-right-click {
  display: none;
}
.mini-table-template .mini-right-click {
  left: auto;
  right: 20px;
}
.mini-table-template .mini-table {
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  gap: 10px;
}
.mini-table-template .mini-table .mini-table-regular-view {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  width: 270px;
  flex-shrink: 0;
}
.mini-table-template .mini-table .mini-table-regular-view thead th {
  padding: 8px 12px;
  border-bottom: 1px solid var(--table-border);
  color: var(--table-header-text-color);
  font-size: 11px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: start;
}
.mini-table-template .mini-table .mini-table-regular-view tbody tr:nth-child(odd) td {
  background: var(--table-body-tr-bg);
}
.mini-table-template .mini-table .mini-table-regular-view tbody tr:last-child td {
  border: 0;
}
.mini-table-template .mini-table .mini-table-regular-view tbody td {
  padding: 12px;
  text-align: start;
  border-bottom: 1px solid var(--table-border);
  color: var(--table-header-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/miniTable/miniTable.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AACR;AACY;EACI,oCAAA;AAChB;AAEQ;EACG,aAAA;AAAX;AAII;EAEI,UAAA;EACA,WAAA;AAHR;AAMI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAJR;AAKQ;EACI,kBAAA;EACA,gDAAA;EACA,YAAA;EACA,cAAA;AAHZ;AAKgB;EACI,iBAAA;EACA,4CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AAHpB;AASwB;EACI,mCAAA;AAP5B;AAWwB;EACI,SAAA;AAT5B;AAagB;EACI,aAAA;EACA,iBAAA;EACA,4CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAXpB","sourcesContent":[".mini-table-template {\n    display: flex;\n    gap: 10px;\n    padding: 6px 12px 6px 45px;\n    align-items: center;\n    position: relative;\n\n    .mini-left-click {\n        position: absolute;\n        border-radius: 32px;\n        background: var(--sdk-global-white);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 0px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        left: 20px;\n        top: auto;\n        cursor: pointer;\n        flex-shrink: 0;\n        z-index: 9;\n        svg{\n            path{\n                stroke: var(--sdk-gloabl-text-color);\n            }\n        }\n        &.hide {\n           display: none;\n        }\n    }\n\n    .mini-right-click {\n        @extend .mini-left-click;\n        left: auto;\n        right: 20px;\n    }\n\n    .mini-table {\n        display: flex;\n        align-items: flex-start;\n        overflow: hidden;\n        gap: 10px;\n        .mini-table-regular-view{\n            border-radius: 4px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            width: 270px;\n            flex-shrink: 0;\n            thead{\n                th{\n                    padding: 8px 12px;\n                    border-bottom: 1px solid var(--table-border);\n                    color: var(--table-header-text-color);\n                    font-size: 11px;\n                    font-weight: 600;\n                    line-height: normal;\n                    letter-spacing: 0.5px;\n                    text-transform: uppercase;\n                    text-align: start;\n                }\n            }\n            tbody{\n                tr{\n                    &:nth-child(odd){\n                        td{\n                            background: var(--table-body-tr-bg);\n                        }\n                    }\n                    &:last-child{\n                        td{\n                            border: 0;\n                        }\n                    }\n                }\n                td{\n                    padding: 12px;\n                    text-align: start;\n                    border-bottom: 1px solid var(--table-border);\n                    color: var(--table-header-text-color);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: 18px;\n                    vertical-align: middle;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
